import script from "./MarketInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./MarketInfo.vue?vue&type=script&setup=true&lang=ts"

import "./MarketInfo.vue?vue&type=style&index=0&id=408a1b4e&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-408a1b4e"]])

export default __exports__